import gsap from "gsap";

function initWheel() {
  const animationDuration = 0.35;
  const wheel = document.querySelector("section.wheel") as HTMLElement;
  if (!wheel) return;

  const prevBtn = wheel.querySelector(".wheel-controller-button--prev") as HTMLButtonElement;
  const nextBtn = wheel.querySelector(".wheel-controller-button--next") as HTMLButtonElement;
  const clickArea = wheel.querySelector(".wheel-clickArea") as HTMLElement;
  const wheelContent = wheel.querySelector(".wheel-content") as HTMLElement;
  const innerWheel = wheel.querySelector(".wheel-graph-inner") as HTMLElement;

  let currentState = parseInt(wheel.getAttribute("data-state") || "0");

  const handleBtnEvent = (event: MouseEvent | TouchEvent, isPrev: boolean) => {
    event.preventDefault();

    if (wheel.classList.contains("is-active")) return;

    if (isPrev) {
      currentState--;
    } else {
      currentState++;
    }
    updateController();
    updateWheel();
  };

  const updateController = () => {
    prevBtn.disabled = currentState === 0 || wheel.classList.contains("is-active");
    nextBtn.disabled = currentState === 5 || wheel.classList.contains("is-active");
  };

  const updateWheel = () => {
    wheel.setAttribute("data-state", currentState.toString());
    updateContent();
  };

  const updateContent = () => {
    wheel.classList.add("is-active");

    for (let i = 0; i < 6; i++) {
      const text = wheel.querySelector(`.wheel-content-text--${i}`);
      text?.setAttribute("aria-hidden", (i !== currentState).toString());
      const direction = currentState > i ? "left" : "right";
      if (text) {
        if (i === currentState) {
          gsap.to(text, {
            opacity: 1,
            duration: animationDuration,
            pointerEvents: "all",
            delay: 0.25,
            translateX: 0,
            onComplete: () => {
              wheel.classList.remove("is-active");
              updateController();
            },
          });
          wheelContent.style.height = `${text.getClientRects()[0].height}px`;
        } else {
          gsap.to(text, {
            opacity: 0,
            duration: animationDuration,
            pointerEvents: "none",
            translateX: direction === "right" ? "100%" : "-100%",
            onComplete: () => {
              updateController();
            },
          });
        }
      }
    }
  };
  updateContent();

  prevBtn?.addEventListener("click", (event) => handleBtnEvent(event, true));
  prevBtn?.addEventListener("touchstart", (event) => handleBtnEvent(event, true));

  nextBtn?.addEventListener("click", (event) => handleBtnEvent(event, false));
  nextBtn?.addEventListener("touchstart", (event) => handleBtnEvent(event, false));

  for (let i = 1; i <= 5; i++) {
    const clickAreas = wheel.querySelector(`#wheel-clickArea-${i}`);
    clickAreas?.addEventListener("click", () => {
      currentState = i;
      updateWheel();
      updateController();
    });

    clickAreas?.addEventListener("touchstart", () => {
      currentState = i;
      updateWheel();
      updateController();
    });

    clickAreas?.addEventListener("mouseenter", () => {
      for (let j = 1; j <= 5; j++) {
        if (j === i) {
          wheel.setAttribute("data-hover-state", j.toString());
        }
      }
    });

    clickArea?.addEventListener("mouseleave", () => {
      wheel.removeAttribute("data-hover-state");
    });
  }

  innerWheel.addEventListener("click", () => resetWheel());
  innerWheel.addEventListener("touchstart", () => resetWheel());

  const resetWheel = () => {
    currentState = 0;
    updateWheel();
    updateController();
  };

  // reset wheel on resize
  let windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const handleResize = () => {
    const newWindowWidth = window.innerWidth || document.documentElement.clientWidth;
    if (newWindowWidth !== windowWidth) {
      windowWidth = newWindowWidth;
      if (windowWidth < 1024) {
        currentState = 0;
        updateWheel();
        updateController();
      }
    }
  };
  window.addEventListener("resize", handleResize);
}

initWheel();
